module.exports = __webpack_public_path__ + "media/audio100.899fc8e6.mp3";